const getClassNameInfo = (className) => {
    if (!className)
        return [undefined, undefined];
    let classArr = className.split(" ");
    let customWidth = "auto"; // default hodnota

    // Ak sa v classArr nachádza "detail-large" alebo "detail-small", nastav customWidth a odstráň tieto triedy
    if (classArr.includes("detail-large")) {
        customWidth = "detail-large";
        classArr = classArr.filter(cls => cls !== "detail-large");
    } else if (classArr.includes("detail-small")) {
        customWidth = "detail-small";
        classArr = classArr.filter(cls => cls !== "detail-small");
    }

    // Zvyšné triedy spájame späť do reťazca
    const customClass = classArr.join(" ");

    return [customWidth, customClass];
};


// Pri existencii objektov so zhodnym atributom field, sa z detailSchemy
// objekt vymaze a doplnia sa jeho atributy do objektu UI schemy
const updateBlock = (schema, block) => {
    const schemaBlockIndex = schema.findIndex(schemaBlock => schemaBlock.field === block?.field);

    if (schemaBlockIndex !== -1) {
        const schemaBlock = schema.splice(schemaBlockIndex, 1);
        const [customWidth, customClass] = getClassNameInfo(block?.className);
        return { ...schemaBlock[0], customWidth, customClass };
    }
    else {
        const [customWidth, customClass] = getClassNameInfo(block?.className);
        if (block.title) {
            return { ui_type: "title", customWidth, customClass, title: block.title, field: crypto.randomUUID().toString() }
        }
        if (block.customComponent) {
            return { ui_type: "customComponent", customWidth, customClass, customComponent: block.customComponent, field: crypto.randomUUID().toString() }
        }
    }

    return block;
}

const mapRawToBuildArea = (schema, input) => {
    return input.map((tab) =>
        tab.map((row) => {
            if (row.some(col => col.some(field => field.line))) {
                return {
                    type: "line",
                    line: row[0][0].line,
                };
            }

            return {
                type: "row",
                data: row.map((col) => ({
                    type: "column",
                    data: col.map((field) => updateBlock(schema, field)),
                })),
            };
        })
    );
};

// Volanie rekurzivnej funkcie pre upravu UI schemy,
// funckia vracia objekt s upravenou kopiou detailSchema a UI schema
const loadUiBlocks = (schema, ui) => {
    const temp = mapRawToBuildArea(schema, ui);
    return { schema: schema, remapedUI: temp };
}

export default loadUiBlocks;